module.exports = __webpack_public_path__ + "img/qp.6e373bca.svg";